export class StripeMetadata {

    ordine: string;
    cantina: string;
    visitaId: string;
    visita: string;
    visitaMese: string;
    clienteId: string;
    cliente: string;
    email: string;
    telefono: string;
    lingua: string;
    noteOrdine: string;
    puntiTimer: number;
    wineCoinsDintorni: number;

    constructor(
        ordine: string,
        cantina: string,
        visitaId: string,
        visita: string,
        visitaMese: string,
        clienteId: string,
        cliente: string,
        email: string,
        telefono: string,
        lingua: string,
        noteOrdine: string,
        puntiTimer: number,
        wineCoinsDintorni: number
    ) {
        this.ordine = ordine;
        this.cantina = cantina;
        this.visitaId = visitaId;
        this.visita = visita;
        this.visitaMese = visitaMese;
        this.clienteId = clienteId;
        this.cliente = cliente;
        this.email = email;
        this.telefono = telefono;
        this.lingua = lingua;
        this.noteOrdine = noteOrdine;
        this.puntiTimer = puntiTimer;
        this.wineCoinsDintorni = wineCoinsDintorni;
    }
}
